//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import dayjs from "dayjs";
export default {
  name: "loginInfo",
  data() {
    return {
      messageQueue: [], // 消息队列
      processing: false, // 是否正在处理队列
      messages: [], // 存储 WebSocket 推送的消息
      socket: null, // WebSocket 实例
      showAnimation: false,
      curUser: {},
      animationList: [],
      animationText: false,
    };
  },
  computed: {
    ...mapState({
      showLogin: (state) => state.showLogin,
      isLogin: (state) => state.isLogin,
      UUID: (state) => state.UUID,
      loginEffect: (state) => state.loginEffect,
    }),
  },
  mounted() {
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  },
  activated() {
    this.initWebSocket();
  },
  deactivated() {
    this.clearData();
  },
  watch: {
    async isLogin() {
      await this.clearData();
      this.initWebSocket();
    },
  },
  methods: {
    clearData() {
      if (this.socket) {
        this.socket.close();
        this.socket = null;
      }

      this.messageQueue = [];
      this.processing = false;
      this.messages = [];
      this.showAnimation = false;
      this.curUser = {};
      this.animationList = [];
      this.animationText = false;
    },
    handleVisibilityChange() {
      if (document.hidden) {
        this.clearData();
      } else {
        this.initWebSocket();
      }
    },
    initWebSocket() {
      if (this.socket) return;
      const url = `${window.location.protocol === "https:" ? "wss" : "ws"}://${
        window.location.host
      }/api/ws/${
        this.UUID || dayjs().valueOf() + Math.floor(Math.random() * 1000)
      }`;
      this.socket = new WebSocket(url);

      this.socket.onmessage = (event) => {
        if (this.showLogin) return;
        const data = event.data;
        if (data) {
          const parseData = JSON.parse(data);
          const timestamp = dayjs().valueOf();
          parseData.id = timestamp + Math.random(); // 给每条消息一个唯一 ID
          this.messageQueue.push(parseData); // 推入消息队列
          this.processQueue(); // 处理队列
          // this.addMessage(parseData);
        }
      };

      this.socket.onclose = () => {
        console.warn(`WebSocket ${url} 连接关闭`);
      };
    },

    processQueue() {
      if (this.processing || this.messageQueue.length === 0) return;

      this.processing = true;

      const processNext = () => {
        if (this.messageQueue.length === 0) {
          this.processing = false;
          return;
        }

        const message = this.messageQueue.shift(); // 取出队列中的第一条消息
        this.addMessage(message);

        setTimeout(() => {
          processNext();
        }, 1000); // 每隔 1 秒处理下一条消息
      };

      processNext();
    },

    addMessage(message) {
      this.messages.push(message);
      if (message.noticeType !== "1" && this.loginEffect) {
        this.animationList.push(message);
        this.handleAnimation();
      }
      // 设置 4 秒后删除消息
      requestAnimationFrame(() => {
        setTimeout(() => {
          this.messages = this.messages.filter(
            (item) => item.id !== message.id
          );
        }, 3000); // 4 秒后触发离场动画
      });
    },
    startScrolling() {
      const scrollContainer = this.$el;
      const scrollText = scrollContainer.querySelectorAll(".scroll-text");
      scrollText.forEach((text) => {
        text.addEventListener("animationend", () => {}, { once: true });
      });

      if (this.messages.length > 10) {
        this.messages.shift();
      }
    },
    async handleAnimation() {
      if (this.showAnimation) return;

      while (this.animationList.length > 0) {
        this.curUser = this.animationList.shift(); // 获取当前动画用户

        this.showAnimation = true; // 显示动画

        await this.delay(1500); // 1.8秒后显示文本
        this.animationText = true;

        await this.delay(600); // 0.8秒后隐藏动画
        this.showAnimation = false;
        this.animationText = false;
        this.curUser = {}; // 清空当前动画用户
        await this.delay(200); // 0.2秒后继续下一个动画
      }
    },

    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/Home/components/loginInfo.vue